import { api } from "lwc";

import { Size, Variant } from "tds/button";
import ButtonIcon from "tds/buttonIcon";

// Maps number of characters in count to class names.
const countSizeClassNames: string[] = ["", "", "size--medium", "size--large"];

export default class ButtonIconCount extends ButtonIcon {
  @api maxCount = 50;
  @api href: string | null = null;
  @api target: string | null = null;
  @api rel: string | null = null;
  @api count: number = 0;
  @api size: Size = "large";
  @api sprite: string = "utility";
  @api symbol: string = null!;
  @api variant: Variant = "bare";

  private get formattedCount() {
    return this.count > this.maxCount ? `${this.maxCount}+` : `${this.count}`;
  }

  private get showCount() {
    return this.count > 0;
  }

  private get countClassName() {
    const numChars = this.formattedCount.length;
    let sizeClass = countSizeClassNames[numChars];
    if (sizeClass === undefined) {
      sizeClass = "size--large";
    }
    return `button-icon-count__count ${sizeClass}`;
  }
}
